if (!customElements.get('multicolumn-video-player')) {
    customElements.define(
        'multicolumn-video-player',
        class MulticolumnVideoPlayer extends HTMLElement {
            constructor() {
                super();
                this.wrapper = this.querySelector('[data-video-wrapper]');
                this.video = this.querySelector('video');
                this.playButton = this.querySelector('.multicolumn-video-play-button');
                this.init();
            }

            init() {
                if (!this.video || !this.playButton || !this.wrapper) return;

                // Handle button clicks
                this.playButton.addEventListener('click', this.togglePlay.bind(this));

                // Handle wrapper clicks (entire video area)
                this.wrapper.addEventListener('click', (e) => {
                    if (e.target !== this.playButton) {
                        this.togglePlay();
                    }
                });

                // Update state when video plays/pauses
                this.video.addEventListener('play', () => {
                    this.wrapper.classList.add('playing');
                    // Once played, hide the button permanently
                    this.wrapper.classList.add('has-played');
                });

                this.video.addEventListener('pause', () => {
                    this.wrapper.classList.remove('playing');
                    // Keep has-played class so button stays hidden
                });

                this.video.addEventListener('ended', () => {
                    this.wrapper.classList.remove('playing');
                    // Keep has-played class so button stays hidden
                });
            }

            togglePlay() {
                if (this.video.paused) {
                    this.video.play();
                } else {
                    this.video.pause();
                }
            }
        }
    );
}
